<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{ $route.meta.title }}</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>

      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="批次" prop="batchName">
            <el-input placeholder="请输入批次名称"
                      v-model="search.batchName"
                      clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetSearch()"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="project_number"
                         label="项目编号"
                         min-width="120"></el-table-column>
        <el-table-column prop="project_name"
                         label="项目名称"
                         min-width="200"></el-table-column>
        <el-table-column prop="batch_name"
                         label="批次名称"
                         min-width="300"></el-table-column>
        <el-table-column prop="pending_review"
                         label="待审核"
                         min-width="100"
                         align="center"></el-table-column>
        <el-table-column prop="review_failed"
                         label="审核未通过"
                         min-width="120"
                         align="center"></el-table-column>
        <el-table-column prop="closed"
                         label="已关闭"
                         min-width="100"
                         align="center"></el-table-column>
        <el-table-column prop="review_passed"
                         label="审核通过"
                         min-width="100"
                         align="center"></el-table-column>
        <el-table-column label="操作"
                         min-width="120"
                         align="center">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="handleStartReview(scope.row)">开始审单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  name: 'BatchOrderReviewTable',
  data () {
    return {
      search: {
        projectId: '',
        customerid: null,
        batchName: '',
      },
      // 搜索字段类型声明，用于路由参数类型转换
      searchFieldType: {
        projectId: Number,
      },
    }
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      // 转换搜索参数为接口需要的格式
      const requestParams = {
        batch_name: params.batchName || '',
        current_page: params.current_page || 1,
        per_page: params.per_page || 20,
      }
      // 从路由参数获取项目ID，必须传递
      if (params.projectId) {
        requestParams.projectid = params.projectId
      }
      if (params.customerid) {
        requestParams.customerid = params.customerid
      }
      // 移除空字符串参数
      Object.keys(requestParams).forEach(key => {
        if (requestParams[key] === '') {
          delete requestParams[key]
        }
      })
      return request.page('getBatchOrderReviewTable', requestParams)
    },
    async handleStartReview (row) {
      const batchId = parseInt(row.batchid)
      if (!batchId) {
        this.$message.error('批次ID无效，无法开始审单')
        return
      }

      try {
        const {data} = await request.common('createAuditTask', {projectid: parseInt(row.projectid), batchid: batchId})
        const orderId = parseInt(data && data.orderid)
        if (!orderId) {
          this.$message.error('未获取到可审核工单，请稍后重试')
          return
        }
        this.$router.push({
          path: `/order/review/${orderId}`,
        })
      } catch (e) {
        // 接口错误由全局错误弹窗处理，这里不再额外 toast
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/customer/pages/BatchOrderReviewTable.vue